import React from 'react';
import {
  HeaderRightBlock,
  Headline,
  SectionHeaderContainer,
  StyledLink,
  StyledLinkComponent
} from './styled';
import { NewSectionHeaderProps, RightLinkProps } from './types';
import { CustomLink } from '../CustomLink';

export const RightLink: React.FC<RightLinkProps> = ({
  asLink,
  cypress,
  urlTitle,
  url
}) => (
  <CustomLink
    as={asLink}
    href={url}
    target="_self"
    cypress="show-all-link"
    stat={`${cypress}-all-link`}
    styledLink={StyledLinkComponent}
  >
    <StyledLink tag="body_1">{urlTitle}</StyledLink>
  </CustomLink>
);

export const NewSectionHeader = ({
  title,
  cypress,
  url = null,
  urlTitle = '',
  rightBlock = null,
  headlineType = 'h4',
  asLink = '',
  showBothRightBlocks = false,
  stackOnMobile = false,
  hideOnDesk = false
}: NewSectionHeaderProps) => {
  const SectionLink = url && (
    <RightLink {...{ asLink, url, urlTitle, cypress }} />
  );

  return (
    <SectionHeaderContainer
      $stackOnMobile={stackOnMobile}
      $hideOnDesk={hideOnDesk}
    >
      {typeof title === 'string' ? (
        <Headline tag={headlineType} data-cy={cypress}>
          {title}
        </Headline>
      ) : (
        <div data-cy={cypress}>{title}</div>
      )}
      <HeaderRightBlock>
        {showBothRightBlocks ? (
          <>
            {SectionLink}
            {rightBlock}
          </>
        ) : (
          rightBlock || SectionLink
        )}
      </HeaderRightBlock>
    </SectionHeaderContainer>
  );
};
